import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import supabase from "../../supabaseClient";
import { Box, Typography } from "@mui/material";

const Logout = () => {
	const navigate = useNavigate();

	useEffect(() => {
		const logoutUser = async () => {
			try {
				const { error } = await supabase.auth.signOut();
				if (error) throw error;
			} catch (error) {
				console.error("Error logging out:", error.message);
			} finally {
				// Redirect to the home page after logout and reload the page
				navigate("/");
			}
		};

		logoutUser();
	}, [navigate]);

	return (
		<Box sx={{ textAlign: "center", marginTop: "20px" }}>
			<Typography variant="h5">Logging out...</Typography>
			<Typography variant="body1">
				You will be redirected to the home page shortly.
			</Typography>
			<Typography variant="body1">
				If you are not redirected, click{" "}
				<a href="/" style={{ textDecoration: "underline" }}>
					here
				</a>
				.
			</Typography>
		</Box>
	);
};

export default Logout;
